import _ from "lodash";
import { ACTION_MAPPING, DEFAULT_LENDER_OBJECT } from "./constants";

export function getUpdatedStateData(state, { action, data }) {
  let updatedProduct = _.cloneDeep(state.newCycle);
  //   let list = {};
  const { productID } = data;
  const ACTION_FUNCTIONS = {
    [ACTION_MAPPING.saveProductLenderMap]: (
      updatedProduct,
      productID,
      data,
      state,
      DEFAULT_LENDER_OBJECT
    ) => {
      const { lenders } = data;
      const list = _.reduce(
        lenders,
        (acc, lender) => {
          const obj = _.find(state.lenders, { lender_id: lender });
          acc[lender] = { ...DEFAULT_LENDER_OBJECT, ...obj };
          return acc;
        },
        {}
      );
      updatedProduct[productID] = {
        ...updatedProduct[productID],
        lenders: list,
      };
    },

    [ACTION_MAPPING.saveProductLimit]: (updatedProduct, productID, data) => {
      const { limit } = data;
      updatedProduct[productID] = {
        ...updatedProduct[productID],
        product_limit_snapshot: limit,
      };
    },

    [ACTION_MAPPING.saveScheduleDate]: (updatedProduct, productID, data) => {
      const { scheduleDate } = data;
      console.log("saving scheduleDate", scheduleDate);
      updatedProduct.scheduleDate = scheduleDate;
    },

    [ACTION_MAPPING.saveLenderRank]: (updatedProduct, productID, data) => {
      const { lenderID, value } = data;
      updatedProduct[productID].lenders[lenderID] = {
        ...updatedProduct[productID].lenders[lenderID],
        rank: value,
      };
    },

    [ACTION_MAPPING.saveLimit]: (updatedProduct, productID, data) => {
      const { lenderID, value } = data;
      updatedProduct[productID].lenders[lenderID] = {
        ...updatedProduct[productID].lenders[lenderID],
        lender_limit_snapshot: value,
      };
    },

    [ACTION_MAPPING.editLenderRanking]: (
      updatedProduct,
      productID,
      data,
      state
    ) => {
      let tempObj = _.cloneDeep(state.fundingCycle.product_details);
      _.forEach(tempObj, function (object) {
        let lenders = {};
        _.forEach(object.lenders, function (lender) {
          lenders[lender.lender_id] = lender;
        });
        updatedProduct[object.code] = object;
        updatedProduct[object.code].lenders = lenders;
      });
    },
  };

  if (ACTION_FUNCTIONS[action]) {
    ACTION_FUNCTIONS[action](
      updatedProduct,
      productID,
      data,
      state,
      DEFAULT_LENDER_OBJECT
    );
  }

  //TODO:Keeping this logic here to ensure stability from above optimised code, will remove commented code after integration testing
  //   switch (action) {
  //     case ACTION_MAPPING.saveProductLenderMap: {
  //       const { lenders } = data;
  //       _.forEach(lenders, function (lender) {
  //         let obj = _.filter(state.lenders, { lender_id: lender })[0];
  //         // let lenderDetails = {};
  //         // if (_.size(updatedProduct[productID].lenders) > 0) {
  //         //   lenderDetails = updatedProduct[productID].lenders[lender];
  //         // }
  //         list[lender] = {
  //           ...DEFAULT_LENDER_OBJECT,
  //           ...obj,
  //         };
  //       });

  //       updatedProduct[productID] = {
  //         ...updatedProduct[productID],
  //         lenders: list,
  //       };
  //       break;
  //     }

  //     case ACTION_MAPPING.saveProductLimit: {
  //       const { limit } = data;
  //       updatedProduct[productID] = {
  //         ...updatedProduct[productID],
  //         product_limit_snapshot: limit,
  //       };
  //       break;
  //     }

  //     case ACTION_MAPPING.saveLenderRank: {
  //       const { lenderID, value } = data;
  //       updatedProduct[productID].lenders[lenderID] = {
  //         ...updatedProduct[productID].lenders[lenderID],
  //         rank: value,
  //       };
  //       break;
  //     }

  //     case ACTION_MAPPING.saveLimit: {
  //       const { lenderID, value } = data;

  //       updatedProduct[productID].lenders[lenderID] = {
  //         ...updatedProduct[productID].lenders[lenderID],
  //         lender_limit_snapshot: value,
  //       };
  //       break;
  //     }

  //     case ACTION_MAPPING.editLenderRanking: {
  //       let tempObj = _.cloneDeep(state.fundingCycle.product_details);

  //       _.forEach(tempObj, function (object) {
  //         let lenders = {};
  //         _.forEach(object.lenders, function (lender) {
  //           lenders[lender.lender_id] = lender;
  //         });
  //         updatedProduct[object.code] = object;
  //         updatedProduct[object.code].lenders = lenders;
  //       });
  //       break;
  //     }

  //     default:
  //       break;
  //   }

  return updatedProduct;
}

export function isLimitSnapshotEmpty(limit){
  if(limit === -1 || limit === "" || limit === null){
    return true;
  }
  return false;
}
